module.exports = __webpack_public_path__ + "img/emoji_64.c1ec1a7f.png";